import Cookies from 'js-cookie';
import inBrowser from 'src/utils/inBrowser';

const IsLoggedIn = inBrowser && !!Cookies.get('user') && !!Cookies.get('token');

export default IsLoggedIn;